module.exports = __webpack_public_path__ + "img/bitshake-tools.a52dbfcc.png";